import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { Note } from '../../data/types';

export type CaseNoteState = {
    notes: Note[],
}

export const useCaseNoteState = () => {
    const noteState = useSelector((state: RootState | any) => state.caseNotes as CaseNoteState);
    return noteState;
}

// Define the initial state using that type
const initialState: CaseNoteState = {
    notes: [],
}

export const caseNoteSlice = createSlice({
    name: 'caseNotes',
    initialState: initialState,
    reducers: {
        setCaseNotesAction: (state, action: PayloadAction<Note[]>) => {
            state.notes = action.payload;
        },
        addOrReplaceCaseNoteAction: (state, action: PayloadAction<Note>) => {
            const existingIndex = state.notes.findIndex((note: Note) => note?.noteId === action.payload.noteId);
            if (existingIndex >= 0) {
                state.notes[existingIndex] = action.payload;
            } else {
                state.notes.push(action.payload);
            }
        },
        addOrReplaceCaseNotesAction: (state, action: PayloadAction<Note[]>) => {
            action.payload.forEach((note) => {
                const existingIndex = state.notes.findIndex((n: Note) => n?.noteId === note.noteId);
                if (existingIndex >= 0) {
                    state.notes[existingIndex] = note;
                } else {
                    state.notes.push(note);
                }
            });
        },
        deleteCaseNoteAction: (state, action: PayloadAction<string>) => {
            state.notes = state.notes.filter((x) => x.noteId !== action.payload);
        },
    }
})

export const { addOrReplaceCaseNoteAction, addOrReplaceCaseNotesAction, setCaseNotesAction, deleteCaseNoteAction } = caseNoteSlice.actions;
export default caseNoteSlice.reducer;